import { Box, IconButton, Typography, useTheme, Link, useMediaQuery, Skeleton } from '@mui/material'
import { getPolygonscanAddressUrl } from 'src/common/utils'

import { LinkIcon } from 'src/assets/icons'

import { useStyles } from './styles'

interface IProps {
  balance: string
  currency: string
  defaultAddress: string
  isLoading: boolean
}

export const UserWalletsBalanceItem = ({
  balance,
  currency,
  defaultAddress,
  isLoading,
}: IProps) => {
  const theme = useTheme()
  const classes = useStyles()

  // const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const isTablet = true
  if (isLoading) {
    return <Skeleton variant="rounded" width={isTablet ? 80 : 85} height={isTablet ? 26 : 32} />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.custom.lightGreen,
        p: isTablet ? '0px 0px 0px 5px' : '3px 5px',
        borderRadius: isTablet ? '4px' : '8px',
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: isTablet ? '10px' : '12px',
          color: theme.palette.custom.grey2,
          pr: '3px',
        }}
      >
        {currency}:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: isTablet ? '10px' : '12px',
          color: theme.palette.custom.grey2,
        }}
      >
        {balance}
      </Typography>
      <IconButton
        disabled={!defaultAddress}
        size="small"
        component={Link}
        href={defaultAddress ? getPolygonscanAddressUrl(defaultAddress) : '#'}
        target="_blank"
      >
        <LinkIcon className={classes.copyIcon} />
      </IconButton>
    </Box>
  )
}
